import { AbstractControl, ValidatorFn } from '@angular/forms';

function onlyNumber(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value?.length
      || !isNaN(+(control.value?.toString().trim()))) {

      return null;
    }
    return { onlyNumber: control.value };
  };
}

function onlyPositiveNumber(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null =>
    /^[0-9]*$/.test(control.value?.toString().trim()) ? null : { onlyNumber: control.value };
}

function time(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    const error = { [CustomValidatorTypes.time]: true }

    if (!value) { return null; }
    return /^(2[0-3]|[0-1][\d])[0-5][\d]$/.test(value.toString().trim())
        ? null
        : error;
  }
}

function date(required = false): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!required && !control.value) {
      // console.log('IsDate validator: OK');
      return null;
    }
    if (required && !control.value) {
      return { required: true };
    }
    const isDate = control.value instanceof Date;
    // console.log('IsDate validator: ', isDate, control.value);
    return isDate ? null : { date: control.value };
  };
}

function dateString(format: string): ValidatorFn {
  // todo --- add format parsing and max values for day and month checking
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    return /^(\d){8}$/.test(control.value?.toString()) ? null : { dateString: control.value };
  }
}

function requireNonSpace(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return { required: true };
    }
    return control.value.trim().length ? null : { [CustomValidatorTypes.requireNonSpace]: true };
  }
}

export function validatorUniqueName(nameList?: string[], message?: string, params?: string): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value?.toLowerCase();
    nameList = nameList.map(p => p.toLowerCase());
    if (nameList.includes(value)) {
      console.log('Error obj', {
        duplicate: {
          value: true,
          item: message,
          ...(params && { params })
        }
      });
      return {
        duplicate: {
          value: true,
          item: message,
          ...(params && { params })
        }
      };
    } else {
      return null;
    }
  };
}

export function loginValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const login = control.value;
    const regex = new RegExp(/^[a-zA-Z0-9\-.!@]+$/);
    if (regex.test(login.trim())) {
      return null;
    }
    return { [CustomValidatorTypes.loginFormat]: true }
  }
}

export function lampNumberValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value: string = control.value;
    // const reg = /^[0-9]{3}[A-z][0-9]$/; task #781
    const regSymbol = /[A-Z]+/i;
    const regNumber = /\d+/;
    const formatError = $localize`Неверный формат, только латинские буквы или цифры`;
    if (/[А-ЯЁ]+/i.test(value)) {
      return {
        [CustomValidatorTypes.lampNumberFormat]: { message: formatError }
      };
    }
    if (!regNumber.test(value)) {
      return {
        [CustomValidatorTypes.lampNumberFormat]: {
          message: $localize`Поле должно содержать как минимум одну цифру`
        }
      }
    }
    if (!regSymbol.test(value)) {
      return {
        [CustomValidatorTypes.lampNumberFormat]: {
          message: $localize`Поле должно содержать как минимум одну латинскую букву`
        }
      }
    }

    if (!value || (regSymbol.test(value) && regNumber.test(value))) {
      return null
    }

    return {
      [CustomValidatorTypes.lampNumberFormat]: { message: formatError }
    };
  }
}

export function deviceSerialNumberPattern(): ValidatorFn {
  return (control: AbstractControl) => {
    const value: string = control.value;
    const reg = /^[A-Z]\.[0-9,A-Z]{2}\.[0-9]{3}$/;
    if (!value || reg.test(value)) {
      return null
    }
    return {
      [CustomValidatorTypes.deviceSerialNumber]: {
        message: $localize`Неверный формат, пример: M.2M.001`
      }
    };
  }
}

export const CustomValidators = {
  onlyNumber: onlyNumber(),
  date: date(),
  dateRequired: date(true),
  dateString: dateString,
  time: time(),
  duplicate: validatorUniqueName(),
  requireNonSpace: requireNonSpace(),
  loginFormat: loginValidator(),
  lampNumberFormat: lampNumberValidator(),
  deviceSerialNumber: deviceSerialNumberPattern()
};

export enum CustomValidatorTypes {
  messageRequired = 'messageRequired',
  fileRequired = 'fileRequired',
  messageOrFileRequired = 'messageOrFileRequired',
  customMessage = 'customMessage',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  requireNonSpace = 'requireNonSpace',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  time = 'time',
  loginFormat = 'loginFormat',
  lampNumberFormat = 'lampNumberFormat',
  deviceSerialNumber = 'deviceSerialNumber'
}
